<template>
  <main>
    <img src="@/assets/images/telltomm.svg" alt="TellTOMM" />

    <div class="centered-con" v-if="type === 0">
      <img src="@/assets/images/thumbs_up.png" alt="Thank You Thumbs Up" />
      <p>Thanks.<br />You're all done.</p>
    </div>
    
    <div class="centered-con-asq" v-if="type === 1 || type === 2">
      <img src="@/assets/images/thumbs_up.png" alt="Thank You Thumbs Up" />
      <!-- <p>Thanks.</p> -->
    </div>
    <div class="centered-more-asq" v-if="type === 1">
      <p style="color:#00aaa8">ASQ - 3 results are now saved in notes portal</p>
      <!-- <p>Return to your TOMM tab to:</p>
          <p style="margin-left: 40px; font-weight:100;">Add <span style="font-size:bold!important;">NOTES</span> - In notes portal</p>
          <p style="margin-left: 40px; font-weight:100;">Record <span style="font-size:bold!important;">REFERRALS</span> - under 'Referrals' on assessment page</p> -->
    </div>

    <div class="centered-more-asq" v-if="type === 2">
      <p style="color:#00aaa8">ASQ - SE results are now saved in notes portal</p>
      <!-- <p>Return to your TOMM tab to:</p>
          <p style="margin-left: 40px;font-weight:100;">Record <span style="font-size:bold!important;">REFERRALS</span> - under 'Referrals' on assessment page</p> -->
    </div>

  </main>
</template>

<script>
export default {
  name: 'ThankYou',
  data() {
    return {
      type: 0
    };
  },
  mounted() {
   this.type = Number(window.location.href.substr(-1));
  },
};
</script>

<style lang="scss" scoped>
main {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 800px;
  max-width: 1280px;
  width: 100%;
  height: 100vh;
  background-color: white;
  border-radius: 25px;
  box-shadow: 0 6px 12px rgba(#000, 0.26);
  padding: 25px;
}

.centered-con {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  img {
    margin-bottom: 50px;
  }

  p {
    color: #00aaa8;
    font-weight: 500;
    text-align: center;
    font-size: 20px;
  }
}
.centered-con-asq {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);

  img {
    margin-bottom: 50px;
  }

  p {
    color: #00aaa8;
    font-weight: 500;
    text-align: center;
    font-size: 20px;
  }
}
.centered-more-asq {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);

  img {
    margin-bottom: 50px;
  }

  p {
    color: #404142;
    font-weight: 500;
    text-align: left;
    font-size: 20px;
  }
  span {
    font-weight:500!important;
  }
}
</style>
